// Splits a captured job description into titled sections so the posting can
// lay them out (pay up top, the rest as prose). String-only, so it is SSR-safe.

const stripTags = (html) =>
  html
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;|\u00a0/g, " ")
    .replace(/&amp;/g, "&")
    .trim();

/** Empty paragraphs/headings and trailing line breaks used as spacers. */
const dropSpacers = (html) =>
  html
    .replace(/<(h\d|p)>(\s|&nbsp;|\u00a0|<br\/?>)*<\/\1>/g, "")
    .replace(/(\s|&nbsp;|\u00a0|<br\/?>)+<\/li>/g, "</li>")
    .trim();

/**
 * `[{ title, html }]` for each `<h3>` section of the captured rich text
 * (sub-headings become h3 under the page's h2s). Text before the first
 * heading comes back untitled. Returns [] when the HTML has no sections.
 */
export function jobSections(html = "") {
  const parts = dropSpacers(html).split(/<h3>/);
  if (parts.length < 2) return [];
  return parts
    .map((part, i) => {
      if (i === 0) return { title: "", html: part.trim() };
      const end = part.indexOf("</h3>");
      return {
        title: stripTags(part.slice(0, end)),
        html: part
          .slice(end + 5)
          .replace(/<(\/?)h4>/g, "<$1h3>")
          .trim(),
      };
    })
    .filter(({ title, html }) => title || stripTags(html));
}

/** Plain text of an HTML fragment (for short highlights). */
export const plainText = stripTags;
